export default function() {
    this.loadCurrentUserData()
}
